/*
 * File: Login.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the login form
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import LoginForm from "./components/LoginForm";
import LoginStyles from "../styles/Login";
import { Link } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import logo from "images/MP-GO-Large.png";
import { WithStyles } from "@material-ui/styles";

interface Props extends WithStyles<typeof LoginStyles> {
  error?: JSX.Element;
  loggingIn?: boolean;
  onSubmit: () => void;
  wasAutoLoggedOut?: boolean;
  showLogout: boolean;
}

const Login = ({
  classes,
  error,
  loggingIn,
  onSubmit,
  wasAutoLoggedOut,
  showLogout
}: Props) => (
  <div className={classes.loginPage}>
    <div className={classes.loginContainer}>
      {/* Using flexible empty divs for dynamic spacing */}
      <div className={classes.logoSpacer} />
      <img
        id="mpLogo"
        src={logo}
        alt="MacPractice"
        //Attempting to make sure the logo is not bigger then the login form. Width is 75% of width set in classes.logoSpacer
        style={{
          width: "75%",
          maxWidth: "375px",
          minWidth: "250px"
        }}
      />
      <div className={classes.formSpacer} />
      <LoginForm
        showLogout={showLogout}
        error={error}
        loggingIn={loggingIn}
        onSubmit={onSubmit}
        wasAutoLoggedOut={wasAutoLoggedOut}
      />

      <div className={classes.troubleSpacer} />
      <Link href="https://helpdesk.macpractice.net/hc/en-us/articles/217551937-iPhone-Interface-Logging-In">
        <Button
          className={classes.havingTrouble}
          variant="outlined"
          color="secondary"
        >
          Having trouble logging in?
        </Button>
      </Link>
      <div className={classes.helpSpacer} />
      <div className={classes.helpLinks}>
        <a href="http://help.macpractice.net">HelpDesk</a>
        {" | "}
        <a href="https://helpdesk.macpractice.net/hc/en-us/articles/115005034713-Contact-MacPractice-">
          Contact Support
        </a>
        {" | "}
        <a href="https://www.macpractice.com/company">About Us</a>
      </div>
      <div className={classes.copyrightSpacer} />
      <div className={classes.copyrightBlurb}>
        <Typography variant="caption">
          Version {process.env.REACT_APP_VERSION}
          <br />
        </Typography>
        <Typography variant="caption">
          Copyright © 2004-2021 MacPractice
          <p style={{ fontSize: "9px" }}>
            Apple, Mac, iMac, Mac mini, MacBook, MacBook Air, iPad, iPhone,
            macOS and iOS are registered trademarks of Apple, Inc.
          </p>
        </Typography>
        <Link
          className={classes.acknowledgments}
          color="secondary"
          href={"https://helpdesk.macpractice.net/hc/en-us/articles/215594318"}
        >
          Acknowledgments
        </Link>
      </div>
    </div>
  </div>
);

export default withStyles(LoginStyles)(Login);
